import { h } from 'preact';
import { Skeleton } from './Skeleton';
import styles from '../filters/FilterPanel.module.scss';
export function FilterPanelSkeleton({ count = 3 }) {
    return (h("div", { class: styles.filterPanelWrapper },
        h("div", { class: styles.filterPanel }, Array.from({ length: count }).map((_, index) => (h(Skeleton, { key: index, width: "120px", height: "40px", borderRadius: "40px" }))))));
}
